var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    [
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Thêm nhóm",
            visible: _vm.dialogVisible,
            width: "450px",
            "before-close": _vm.closeDialog,
            "close-on-click-modal": false,
          },
          on: {
            "update:visible": function ($event) {
              _vm.dialogVisible = $event
            },
            open: _vm.handleOpen,
          },
        },
        [
          _c(
            "el-form",
            [
              _c(
                "el-form-item",
                { attrs: { label: "Chọn thêm nhóm" } },
                [
                  _c(
                    "el-select",
                    {
                      staticClass: "button-left",
                      staticStyle: { width: "255px" },
                      attrs: {
                        multiple: "",
                        size: "small",
                        placeholder: "Chọn nhóm",
                      },
                      model: {
                        value: _vm.listGroupSelect,
                        callback: function ($$v) {
                          _vm.listGroupSelect = $$v
                        },
                        expression: "listGroupSelect",
                      },
                    },
                    _vm._l(_vm.listGroup, function (item, index) {
                      return _c("el-option", {
                        key: index,
                        attrs: { label: item.nameGroup, value: item.id },
                      })
                    }),
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "button" },
            [
              _c(
                "el-button",
                {
                  staticStyle: { "margin-left": "180px" },
                  attrs: {
                    type: "success",
                    size: "medium",
                    icon: "el-icon-circle-check",
                    loading: _vm.loadingAddStudent,
                    disabled: _vm.listGroupSelect.length === 0,
                  },
                  on: { click: _vm.handleAddToGroup },
                },
                [_vm._v(" OK")]
              ),
              _c(
                "el-button",
                {
                  attrs: {
                    type: "danger",
                    size: "medium",
                    icon: "el-icon-circle-close",
                  },
                  on: { click: _vm.closeDialog },
                },
                [_vm._v(" Đóng")]
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }